import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-docs-form',
  templateUrl: './docs-form.component.html',
  styleUrls: ['./docs-form.component.css'],
})
export class DocsFormComponent {
  @ViewChild('fileInput') fileInputRef: ElementRef;

  url: string = 'documents';
  id!: string;
  form!: FormGroup;
  upload = false;
  files: any = [];
  imagePreviews: { [key: string]: string } = {};
  isLoading = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });

    this.form = this.fb.group({
      name: ['', [Validators.required]],
      filename: ['', [Validators.required]],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        name: response.name,
        filename: response.filename,
        status: response.status,
      });
    });
  }

  createData(): void {
    this.isLoading = true;
    const dataForm = new FormData();

    Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          dataForm.append(key, JSON.stringify(value));
        } else {
          dataForm.append(key, value as any);
        }
      }
    });

    console.log('files', this.files);

    if (this.files?.length) {
      this.files.forEach((fileObj) => {
        dataForm.append('files', fileObj.file);
      });
    }
    console.log('files2', this.files);

    this.dataService
      .postData(`${this.url}/add`, dataForm)
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.upload = false;
          delete this.imagePreviews;
          this.isLoading = false;
          this.router.navigateByUrl('/documents');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  selectFile() {
    this.fileInputRef.nativeElement.click();
  }

  captureFile(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    //this.files.push(file);
    this.upload = true;
    this.form.patchValue({
      filename: nameFile,
    });
    this.updateFileList(file, 'doc');
    this.previewFile(file, 'doc'); // si quieres previsualización
  }

  updateFileList(file: File, fieldKey: string) {
    const index = this.files.findIndex((f) => f.fieldKey === fieldKey);
    if (index !== -1) {
      this.files[index] = { file, fieldKey }; // reemplazar si ya existe
    } else {
      this.files.push({ file, fieldKey }); // agregar si no existe
    }
  }

  previewFile(file: File, fieldKey: string) {
    const reader = new FileReader();
    reader.onload = () => {
      //this.previewUrl = reader.result as string; // Guardar el preview
      this.imagePreviews[fieldKey] = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeFile(fieldKey: string) {
    console.log('this.files', this.files);
    this.files = this.files.filter((f) => f.fieldKey !== fieldKey);
    delete this.imagePreviews[fieldKey];

    console.log('this.files', this.files);
    console.log('this.imagePreviews', this.imagePreviews);

    if (fieldKey === 'doc') {
      this.upload = false;
      this.form.patchValue({
        filename: '',
      });
    }
  }
}
